import { Link } from "react-router-dom";
import { ArrowRight, ChevronDown } from "lucide-react";
import { AnimatedSection } from "@/components/AnimatedSection";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import femaleExecutiveImage from "@/assets/images/female-executive.jpg";

const differentials = [
  {
    title: "Independência real — não só no discurso",
    description: "Não temos vínculo com nenhum banco, corretora ou gestora. Na prática, isso significa que quando montamos um plano, a única razão é que ele faz sentido para o seu patrimônio. Não ganhamos mais ou menos dependendo do produto que você compra. Simples assim.",
  },
  {
    title: "Remuneração fixa. Zero conflito de interesse.",
    description: "Cobramos uma taxa fixa pela consultoria. Ponto. Não recebemos comissão de terceiros para empurrar produtos de investimento. Você sabe exatamente quanto paga e por quê. Esse modelo garante que estamos 100% alinhados com os seus objetivos — e não com metas de venda de produtos específicos.",
  },
  {
    title: "Tudo conectado. Nada solto.",
    description: "Investimentos, previdência, seguros, planejamento tributário e sucessório — cada peça do seu patrimônio funciona melhor quando faz parte de uma estratégia integrada. A maioria das pessoas tem produtos financeiros espalhados em 3 ou 4 instituições diferentes, sem ninguém olhando o todo. Nós olhamos.",
  },
  {
    title: "Seu plano responde uma pergunta: quando?",
    description: "Quando você vai poder escolher se quer continuar trabalhando — e não precisar. Essa é a pergunta que guia cada decisão do seu planejamento. Não estamos aqui para girar carteira ou perseguir o fundo do momento. Estamos aqui para encurtar o caminho até a sua liberdade financeira, com segurança.",
  },
];

const DifferentialsAccordion = () => {
  return (
    <section id="diferenciais" className="relative overflow-hidden bg-[#FAFAFA]">
      <div className="container-wide">
        <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px]">
          {/* Left side - Accordion */}
          <div className="py-12 sm:py-16 md:py-20 pr-0 lg:pr-12">
            <AnimatedSection className="mb-8">
              <span className="label-sm mb-3 block text-[#112711]">DIFERENCIAL ALLU CAPITAL</span>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-serif font-medium text-[#112711] leading-tight">
                Por que nossos clientes nos{" "}
                <span className="text-[#112711]">escolheram</span>
              </h2>
            </AnimatedSection>

            <AnimatedSection delay={0.1}>
              <Accordion type="single" collapsible defaultValue="item-0" className="w-full">
                {differentials.map((item, index) => (
                  <AccordionItem 
                    key={index} 
                    value={`item-${index}`}
                    className="border-b border-[#112711]/10"
                  >
                    <AccordionTrigger className="py-4 text-left text-[#112711] hover:text-primary hover:no-underline transition-colors">
                      <span className="text-base sm:text-lg font-medium">
                        {item.title}
                      </span>
                    </AccordionTrigger>
                    <AccordionContent className="text-[#112711]/70 text-sm sm:text-base pb-4 pr-8">
                      {item.description}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </AnimatedSection>

            <AnimatedSection delay={0.3} className="mt-8">
              <Link to="/contato" className="btn-primary rounded-full">
                Fale com um especialista
                <ArrowRight className="ml-2 w-4 h-4" />
              </Link>
            </AnimatedSection>
          </div>

          {/* Right side - Image */}
          <div className="hidden lg:block relative">
            <div className="absolute inset-0">
              <img
                src={femaleExecutiveImage}
                alt="Executiva da Allu Capital"
                className="w-full h-full object-cover object-center"
              />
              {/* Gradient overlay to blend with background */}
              <div className="absolute inset-0 bg-gradient-to-r from-[#FAFAFA] via-transparent to-transparent w-1/3" />
            </div>
          </div>
        </div>
      </div>

      {/* Mobile image - shown below accordion on smaller screens */}
      <div className="lg:hidden relative h-80 -mx-4 sm:-mx-6 mt-8">
        <img
          src={femaleExecutiveImage}
          alt="Executiva da Allu Capital"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#FAFAFA] via-transparent to-transparent" />
      </div>
    </section>
  );
};

export default DifferentialsAccordion;
